<template>
  <div class="public-information-block">
    <Banner :type="activeName" :total="total" />

    <Breadcrumb />

    <div class="container-block">
      <el-row :gutter="60">
        <el-col :span="5">
          <ul class="menu-block">
            <li
              @click="menuClick('activities')"
              :class="{ active: activeName === 'activities' }"
            >
              <img src="@/assets/imgs/icon65.png" class="grey" />
              <img src="@/assets/imgs/icon64.png" class="blue" />
              <span>当前会议</span>
            </li>
            <li
              @click="menuClick('already_payment_information')"
              :class="{ active: activeName === 'already_payment_information' }"
            >
              <img src="@/assets/imgs/icon32.png" class="grey" />
              <img src="@/assets/imgs/icon11.png" class="blue" />
              <span>我的参会</span>
            </li>
            <!-- <li
              @click="menuClick('document')"
              :class="{ active: activeName === 'document' }"
            >
              <img src="@/assets/imgs/icon54.png" class="grey" />
              <img src="@/assets/imgs/icon55.png" class="blue" />
              <span>公益文档</span>
            </li>
            <li
              @click="menuClick('video')"
              :class="{ active: activeName === 'video' }"
            >
              <img src="@/assets/imgs/icon56.png" class="grey" />
              <img src="@/assets/imgs/icon57.png" class="blue" />
              <span>公益视频</span>
            </li>
            <li
              @click="menuClick('audio')"
              :class="{ active: activeName === 'audio' }"
            >
              <img src="@/assets/imgs/icon62.png" class="grey" />
              <img src="@/assets/imgs/icon63.png" class="blue" />
              <span>公益音频</span>
            </li> -->
            <!-- <li
              @click="menuClick('payment_information')"
              :class="{ active: activeName === 'payment_information' }"
            >
              <img src="@/assets/imgs/icon32.png" class="grey" />
              <img src="@/assets/imgs/icon11.png" class="blue" />
              <span>资料购买</span>
            </li> -->
            <!-- <li @click="activeName = 'registered_activities'" :class="{active: activeName === 'registered_activities'}">
              <img src="@/assets/imgs/icon65.png" class="grey"/>
              <img src="@/assets/imgs/icon64.png" class="blue"/>
              <span>已报名活动</span>
            </li> -->
          </ul>
        </el-col>
        <el-col :span="19">
          <!--document-公益文档  video-公益视频  audio-音频  already_payment_information-已购买资料  payment_information-资料购买-->
          <DocumentList v-if="activeName === 'document'" />
          <VideoList v-if="activeName === 'video'" />
          <AudioList v-if="activeName === 'audio'" />
          <AlreadyPaymentInformationList
            v-if="activeName === 'already_payment_information'"
          />
          <PaymentInformationList v-if="activeName === 'payment_information'" />
          <JoinActivities v-if="activeName === 'activities'" />
          <RegisteredActivities v-if="activeName === 'registered_activities'" />
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
/**
 * @description 活动资料
 */
import * as api from '@/api/user'
// import * as commonFunc from '@/utils/common-func'

// 面包屑
import Breadcrumb from '@/components/Breadcrumb'
// banner
import Banner from './banner'
// 公益文档
import DocumentList from './document_list'
// 公益视频
import VideoList from './video_list'
// 公益音频
import AudioList from './audio_list'
// 资料购买
import PaymentInformationList from './payment_information_list.vue'
// 已购买资料
import AlreadyPaymentInformationList from './activities_already_payment_information_list.vue'
// 活动报名
// import JoinActivities from './join_activities'
import JoinActivities from './activities_list.vue'
// 已报名活动
import RegisteredActivities from './registered_activities.vue'

export default {
  name: 'publicInformation',
  components: {
    Breadcrumb,
    Banner,
    DocumentList,
    VideoList,
    AudioList,
    JoinActivities,
    PaymentInformationList,
    AlreadyPaymentInformationList,
    RegisteredActivities
  },
  data() {
    return {
      total: 0, // 订单总量
      activeName: 'document' // type document-公益文档  video-公益视频
    }
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    $route() {
      console.log('this.$route.query', this.$route.query)
      if (!this.$route.query.activeName) {
        this.$router.push({
          path: `/activity-information?activeName=activities`
        })
        window.location.reload()
      }
      this.activeName = this.$route.query.activeName
        ? this.$route.query.activeName
        : 'activities'
      // 页面路由变动后，滚动条滚动到顶部
      window.scrollTo(0, 0)
    }
  },
  created() {
    console.log('this.$route.query', this.$route.query)
    if (!this.$route.query.activeName) {
      this.$router.push({
        path: `/activity-information?activeName=activities`
      })
      window.location.reload()
    }
    this.activeName = this.$route.query.activeName
      ? this.$route.query.activeName
      : 'activities'
    this.getOrderTotal() //获取订单总数
  },
  methods: {
    /**
     * @description 获取订单总数
     */
    getOrderTotal() {
      const _this = this
      const _param = {}
      api
        .orderTotal(_param)
        .then((res) => {
          const _data = res.data

          _this.total = _data.order_total || 0
        })
        .catch((err) => {
          console.log(err)
          // _this.$message.error('操作失败，请稍后刷新页面再试！')
        })
    },

    /**
     * @description 左菜单点击
     */
    menuClick(_active) {
      this.activeName = _active
      this.$router.push({
        path: `/activity-information?activeName=${_active}`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.public-information-block {
  > .container-block > .el-row {
    margin-top: 20px;
  }

  .menu-block {
    background: #ffffff;
    margin: 0;
    padding: 30px;
    list-style-type: none;
    padding-bottom: 200px;

    li {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;
      align-items: center;
      font-size: 20px;
      color: #979797;
      height: 60px;
      border-bottom: 2px solid #edeef2;
      cursor: pointer;
      margin: 0 0 20px 0;

      img {
        height: 30px;
        margin: 0 10px 0 0;
      }
    }

    .grey {
      display: block;
    }

    .blue {
      display: none;
    }

    .active {
      color: $colorNormal;
      border-bottom: 2px solid $colorNormal;

      .grey {
        display: none;
      }

      .blue {
        display: block;
      }
    }
  }

  .more-service {
    width: 100%;
    // height: 400px;
    height: 350px;
    background: $colorNormal;
    color: #ffffff;
    text-align: center;
    overflow: hidden;
    margin: 120px 0 -80px 0;

    h2 {
      margin: 140px 0 30px 0;
      font-size: 36px;
      line-height: 1;
    }

    h3 {
      font-size: 22px;
      line-height: 1;
      margin: 0 0 25px 0;
    }

    .more-btn {
      width: 200px;
      height: 60px;
      border-radius: 3px;
      line-height: 60px;
      text-align: center;
      font-size: 30px;
      color: $colorNormal;
      background: #ffffff;
      margin: 0 auto;
    }
  }
}
</style>